import { getStore, setStore, removeStore } from '@/utils/store'
import { TOKEN_KEY, REFRESH_TOKEN_KEY } from '@/utils/request'
import * as env from '@/utils/env'
import * as handle from '@/utils/handle'
import * as store from '@/utils/store'

export function isLogin(): boolean {
  return !!getStore(TOKEN_KEY) && !!getStore(REFRESH_TOKEN_KEY)
}

export function login(token: string, refreshToken: string): void {
  setStore({ name: TOKEN_KEY, content: token })
  setStore({ name: REFRESH_TOKEN_KEY, content: refreshToken })
}

export function logout(): void {
  removeStore(TOKEN_KEY)
  removeStore(REFRESH_TOKEN_KEY)
  setTimeout(() => {
    window.location.reload()
  }, 2000)
}

export { env, handle, store }
